import { deleteOne, fetchStream, get, post, put } from "@/modules/request";
import { Response, WriteResponse } from "@/types/api-types";
import { StoryScene } from "@/types/entity";

export const ApiPostGalGameDialogCreateMany = (itemzz: StoryScene[]) =>
  post(`/GalGameDialog/CreateMany`, { itemzz });

// 创建game
export const ApiPostGalGame = (params: { name: string; mateId: number }) =>
  post("/GalGame", params);

// 克隆game
export const ApiPostCloneGalGame = (id: number) => post("/GalGameClone/" + id);

// 更新game
export const ApiPutGalGame = (id: number, params: GalGame) =>
  put("/GalGame/" + id, params);

// 删除game
export const ApiDeleteGalGame = (id: number) => deleteOne("/GalGame/" + id);

// 发布game
export const ApiPostGalGamePublish = (
  id: number,
  version: string,
  description: string
) => post("/GalGamePublish/" + id, { version, description });

// 获取game
export const ApiGetGalGame = (uuid: string) => get("/GalGame/" + uuid);

export const ApiGetGalGamePage = (
  {
    tab,
    type,
    mateId,
    reviewStatus,
  }: {
    tab?: "hot" | "recommend";
    type?: number;
    mateId?: number;
    reviewStatus?: number; // 1.待审核 2.审核通过 3.审核不通过
  } = {},
  { page = 1, perPage = 999 } = {},
  { field = "dtUpdate", order = "desc" } = {}
) => {
  const params =
    tab === "hot"
      ? {
          tab,
          pagination: { page, perPage },
        }
      : {
          filter: { mateId, type, reviewStatus },
          sort: { field, order },
          pagination: { page, perPage },
        };
  return get("/GalGamePage", params);
};
export const ApiGetMateGalGamePage = (mateId: number, status?: 1 | 2) =>
  get("/MateGalGamePage", {
    filter: { mateId, status },
    sort: { field: "dtUpdate", order: "desc" },
    pagination: {
      page: 1,
      perPage: 999,
    },
  });

// game character
// 重新生成所有音色
export const ApiPostGalGameCharacterDialogToneRegenerate = (id: number) =>
  post(`/GalGameCharacterDialogToneRegenerate/${id}`);

// gameNode
// type: 1.开始节点 2.剧情点 3.结束节点
export const ApiPostGalGameStoryNode = (galGameId: number, type: number) =>
  post("/GalGameStoryNode", { galGameId, type });

// 更新gameNode
export const ApiPutGalGameStoryNode = (id: number, params: GalGameNode) =>
  put("/GalGameStoryNode/" + id, params);

// 删除gameNode
export const ApiDeleteGalGameStoryNode = (id: number) =>
  deleteOne("/GalGameStoryNode/" + id);

// 获取gameNode
export const ApiGetGalGameStoryNode = (galGameId: number) =>
  get("/GalGameStoryNode", { galGameId });

// storyNode 克隆
export const ApiPostGalGameStoryNodeClone = (storyNodeId: number) =>
  post("/GalGameStoryNodeClone/" + storyNodeId);

// gameNode排序
export const ApiPostGalGameStoryNodeSort = (params: {
  galGameId: number;
  storyNodeIdzz: number[];
}) => post("/GalGameStoryNodeSort", params);

// galGameDialog
// 创建
export const ApiPostGalGameDialog = (
  params: Pick<
    GalGameDialog,
    "storyNodeId" | "characterId" | "text" | "sceneMediaId" | "mateToneId"
  >
) => post("/GalGameDialog", params);

// 更新
export const ApiPutGalGameDialog = (
  id: number,
  params: Partial<
    Pick<
      GalGameDialog,
      | "characterId"
      | "text"
      | "sceneMediaId"
      | "sceneMediaInfo"
      | "audioMediaId"
      | "nextDialogId"
    >
  >
) => put("/GalGameDialog/" + id, params);

// 删除
export const ApiDeleteGalGameDialog = (id: number) =>
  deleteOne("/GalGameDialog/" + id);

// 排序
export const ApiPutGalGameDialogSort = (params: {
  storyNodeId: number;
  dialogIdzz: number[];
}) => post("/GalGameDialogSort", params);

// 获取
export const ApiGetGalGameDialog = (storyNodeId: number) =>
  get("/GalGameDialog", { storyNodeId });

// 获取item
export const ApiGetGalGameDialogItem = (
  dialogId: number
): Promise<WriteResponse<GalGameDialog>> => get(`/GalGameDialog/${dialogId}`);

// 获取dialog page根据 characterid
export const ApiGetGalGameDialogPageByCharacterId = (
  {
    galGameId,
    storyNodeId,
    characterId,
  }: { galGameId: number; storyNodeId?: number; characterId?: number },
  { page = 1, perPage = 999 } = {}
) => {
  const sort = storyNodeId
    ? { field: "order", order: "desc" }
    : { field: "id", order: "asc" };
  return get("/GalGameDialogPage", {
    filter: { galGameId, storyNodeId, characterId },
    pagination: { page, perPage },
    sort,
  });
};

//  根据 dialogId 重新生成音色
export const ApiPostGalGameDialogToneRegenerate = (dialogId: number) =>
  post(`/GalGameDialogToneRegenerate/${dialogId}`);

// dialog option
// 创建
export const ApiPostGalGameDialogOption = (
  params: Pick<GalGameDialogOption, "dialogId" | "text">
) => post("/GalGameDialogOption", params);

// 更新
export const ApiPutGalGameDialogOption = (
  id: number,
  params: Pick<GalGameDialogOption, "nextDialogId" | "text" | "score">
) => put("/GalGameDialogOption/" + id, params);

// 删除
export const ApiDeleteGalGameDialogOption = (id: number) =>
  deleteOne("/GalGameDialogOption/" + id);

// 获取
export const ApiGetGalGameDialogOption = (dialogId: number) =>
  get("/GalGameDialogOption", { dialogId });

// 构建GalGame
export const ApiBuildGalGame = (id: number) => post(`/GalGameBuild/${id}`);

// 自动生成
// galgame 自动补全
export const ApiPostGalGameComplete = (
  params: {
    type: number; // 1恋爱游戏
    name: string;
    description: string;
    character: {
      mateId: number;
      introduction: string;
    };
    player: {
      name: string;
      introduction: string;
    };
  },
  callback: <T>(content: Response<T> | string) => void | Promise<void>
) => fetchStream("/GalGameComplete", "POST", params, callback);

// storyNode 自动补全
export const ApiPostGalGameStoryNodeComplete = (
  params: {
    galGameId: number;
    title: string;
    description: string;
  },
  callback: <T>(content: Response<T> | string) => void | Promise<void>
) => fetchStream("/GalGameStoryNodeComplete", "POST", params, callback);

// storyNode 自动生成
export const ApiPostGalGameStoryNodeGenerate = (galGameId: number) =>
  post("/GalGameStoryNodeGenerate", { galGameId });

// dialog 自动生成
export const ApiPostGalGameDialogGenerate = (storyNodeId: number) =>
  post("/GalGameDialogGenerate", { storyNodeId });

export const ApiPostGalGameDialogPortrait = (params: {
  dialogId: number;
  mediaId: number;
  mediaInfo: MediaTransform;
}) => post(`/GalGameDialogPortrait`, params);

export const ApiDeleteGalGameDialogPortrait = (id: number) =>
  deleteOne(`/GalGameDialogPortrait/${id}`);

export const ApiPutGalGameDialogPortrait = (
  id: number,
  params: {
    mediaId: number;
    mediaInfo: MediaTransform;
  }
) => put(`/GalGameDialogPortrait/${id}`, params);

export const ApiPostGalGameDialogAnimation = (params: {
  dialogId: number;
  animationId: number;
  mediaInfo: MediaTransform;
}) => post(`/GalGameDialogAnimation`, params);

export const ApiDeleteGalGameDialogAnimation = (id: number) =>
  deleteOne(`/GalGameDialogAnimation/${id}`);

export const ApiPutGalGameDialogAnimation = (
  id: number,
  params: {
    animationId: number;
    mediaInfo: MediaTransform;
  }
) => put(`/GalGameDialogAnimation/${id}`, params);

// game media

// 创建
// type: 1.图片 2.视频
export const ApiPostGalGameMedia = (params: {
  galGameId: number;
  mediaId: number;
  type: number;
}) => post(`/GalGameMedia`, params);

// 删除
export const ApiDeleteGalGameMedia = (id: number) =>
  deleteOne(`/GalGameMedia/${id}`);

// 更新
export const ApiPutGalGameMedia = (
  id: number,
  params: {
    mediaId: number;
    type: number;
  }
) => put(`/GalGameMedia/${id}`, params);

// 排序
export const ApiPutGalGameMediaSort = (params: {
  galGameId: number;
  mediaIdzz: number[];
}) => post(`/GalGameMediaSort`, params);

// gal game score
export const ApiGetGalGameScore = (galGameId: number) =>
  get("/GalGameScore", { galGameId });

export const ApiPostGalGameScore = (params: GalGameScore) =>
  post(`/GalGameScore`, params);

export const ApiPutGalGameScore = (
  id: number,
  params: Pick<GalGameScore, "name" | "initialScore" | "description">
) => put(`/GalGameScore/${id}`, params);

export const ApiDeleteGalGameScore = (id: number) =>
  deleteOne(`/GalGameScore/${id}`);
